import { templateHireflixAddVideoInterviewRoute } from '@features/enterprise/api/constants';
import { errorMessage } from '@features/positions';
import axiosInstance from '@server/axiosInstance';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { templateList } from '../constants';

type SubmitJobPosition = {
  template_id: number;
  jobs: {
    job_id: number;
    questions: {
      title: string;
      description: string;
    }[];
  }[];
};

type UseAddJobPositionProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useAddHireflixVideoInterview = ({
  setErrorText = () => {},
}: UseAddJobPositionProps) => {
  const client = useQueryClient();

  const {
    mutate: addHireflixVideoInterview,
    isLoading: isAddingVideoInterviewLoading,
  } = useMutation({
    mutationFn: (variables: SubmitJobPosition) =>
      axiosInstance
        .post(templateHireflixAddVideoInterviewRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        setErrorText('');
        client.invalidateQueries([templateList]);
      } else {
        setErrorText(data?.message ?? errorMessage);
      }
    },
    onError: () => setErrorText(errorMessage),
  });

  return { addHireflixVideoInterview, isAddingVideoInterviewLoading };
};
